
import React from 'react';
import { ConnectionLineComponentProps } from '@xyflow/react';

const WorkflowConnectionLine = ({
  fromX,
  fromY,
  fromPosition,
  toX,
  toY,
  toPosition,
}: ConnectionLineComponentProps) => {
  return (
    <g>
      <path
        d={`M${fromX},${fromY} C ${fromX} ${toY} ${toX} ${fromY} ${toX},${toY}`}
        className="stroke-foreground/50"
        strokeWidth={1.5}
        fill="none"
        strokeDasharray="5,5"
      />
      <circle cx={toX} cy={toY} r={3} fill="var(--primary)" />
    </g>
  );
};

export default WorkflowConnectionLine;
